
import $ from 'jQuery';
import MarketingTracking from './MarketingTracking.js';
import Analytics from '../Analytics/Analytics';
import config from '../../js/config';
import mediator from '../../js/mediator';

export class ArticlesEventsMarketingTracking extends MarketingTracking {
  constructor($el) {
    super();
    this.$el = $el;
    this.model = {};
    if (window.location.href.indexOf('/articles/') > -1) {
      this.model.contentType = 'Article';
    } else if (window.location.href.indexOf('/videos/') > -1) {
      this.model.contentType = 'Video';
    } else if (window.location.href.indexOf('/events/') > -1) {
      this.model.contentType = 'Event';
    }
    this.model.title = this.$el.find('.Article-title').text();
    let pageObject = {
      page: {
        pageInfo: {
          pageType: this.model.contentType
        }
      }
    };
    Analytics.setOnDataLayer(pageObject);
    mediator.on(config.events.cart.userInfoSet, this.pushData, this);
  }

  pushData() {
    setTimeout(() => {
      this.onViewArticlesAndEvents(this.model);
    }, 5);
  }
}

export function createArticlesEventMarketingTracking($parent) {
  $parent.find('#EloquaViewArticlesEventsTracking').each((n, el) => {
    new ArticlesEventsMarketingTracking($(el));
  });
}


// WEBPACK FOOTER //
// ./assets/components/MarketingTracking/ArticlesEventsMarketingTracking.js